/* eslint-disable eqeqeq */
const booleanValueMap: { [key: string]: boolean } = {
    true: true,
    True: true,
    false: false,
    False: false
};

export function getQueryParams<T extends {}>(): T {
    const params = new URLSearchParams(window.location.search);
    let paramsDictionary: any = {};

    params.forEach((value, key) => {
        // @ts-ignore
        if (parseInt(value, 10) == value) {
            paramsDictionary[key] = parseInt(value, 10);
        } else if (booleanValueMap.hasOwnProperty(value)) {
            paramsDictionary[key] = booleanValueMap[value];
        } else {
            paramsDictionary[key] = value;
        }
    });
    return paramsDictionary;
}
